import { render, staticRenderFns } from "./channelShopCell.vue?vue&type=template&id=4b28e49d&scoped=true"
import script from "./channelShopCell.vue?vue&type=script&lang=js"
export * from "./channelShopCell.vue?vue&type=script&lang=js"
import style0 from "./channelShopCell.vue?vue&type=style&index=0&id=4b28e49d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28e49d",
  null
  
)

export default component.exports